module.exports = __webpack_public_path__ + "img/Estatus-MInas-Dona.46088601.png";